module.exports = {"animatingSpeed":"6s","spinSpeed":"6s","position":"absolute","afterInset":"-2px","beforeInset":"0","afterZIndex":"-2","beforeZIndex":"-1"};